// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header,
html {
  background-color: #ddd;
  border-bottom: none;
}

.header {
  box-shadow: 0 0 15px -6px rgba(0, 0, 0, 0.9);
  z-index: 800;
  background-color: #af2811;
}

.lichtgroen {
  background-color: #ddd;
}

.overzicht,
.light {
  color: black;
}

header .menu_main li a {
  color: black;
}

.wel_logo_liggend {
  display: block;
  width: 200px;
  padding-left: 20px;
}

.wel_logo_liggend img {
  width: 100%;
  object-fit: contain;
  display: block;
}

@media screen and (min-width: 768px) {
  .wel_logo_liggend {
    padding-left: auto;
  }
}
.start_offset {
  position: relative;
}

.start_offset::before {
  content: "";
  display: block;
  height: 80px; /* ruimte die je wilt offsetten */
  margin-top: -80px;
}

figcaption {
  font-size: 16px;
  padding-left: 0px;
}

.post_item {
  background-color: #000;
  border-bottom: none;
}

.post_info {
  background-color: white;
}

.post_img {
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: center;
  background-size: cover;
  display: block;
  height: 100px !important;
  width: 120px !important;
}

.white_shape {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.post_title {
  font-family: "Anton", sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: black;
  font-weight: 600;
  padding-bottom: 20px;
  font-size: 25px;
  line-height: 30px;
}

.post_text {
  font-weight: 500;
}

.post {
  margin-top: 0;
  padding-top: 0;
}

.content {
  padding-top: 0;
}

@media screen and (min-width: 768px) {
  .content {
    padding-top: 15px;
  }
  .post {
    margin-top: 15px;
    padding-top: 15px;
  }
  .post_img {
    width: 100% !important;
    height: 260px !important;
    overflow: hidden;
  }
  .post_title {
    font-size: 35px;
    line-height: 37px !important;
    color: #af2811 !important;
  }
}
.post_button a {
  color: black;
  transition: all 0.3s ease-in-out;
}

.post_button a:hover {
  transform: translateY(-4px);
  color: red;
  cursor: pointer;
}

#doek {
  width: 100% !important;
  min-width: auto !important;
  height: auto !important;
}

#doek img {
  height: 300px !important;
}

.swiper-wrapper {
  width: 100% !important;
  min-width: auto !important;
}

.wel_logo {
  width: 500px !important;
  height: 60px !important;
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 501;
  display: block;
}

.wel_logo img {
  width: 100%;
}

@media screen and (min-width: 768px) {
  #doek {
    height: 100vh !important;
  }
  #doek img {
    height: auto !important;
  }
  .swiper-wrapper {
    height: auto !important;
  }
  .wel_logo {
    position: absolute;
    width: 100px;
    bottom: 150px;
    z-index: 501;
    display: block;
  }
}
@media screen and (min-width: 2000px) {
  #doek img {
    height: 80% !important;
  }
}
.content {
  margin: 0 auto;
}

h1 {
  font-family: "FilsonProBold";
  color: #af2811 !important;
}

h3 {
  font-family: "FilsonProBold";
}

h5 {
  text-transform: uppercase;
  font-size: 16px;
  letter-spacing: 1px;
  color: black;
}

.footer {
  display: flex;
  margin-top: 0;
  height: 200px;
  background-color: #000 !important;
}

.colofon {
  color: #fff;
  display: flex !important;
  flex-basis: 100%;
  margin: 0 auto;
}

.colofon p {
  margin-bottom: 20px;
  line-height: 18px;
  font-size: 12px;
}

.colofon p a {
  color: #ffdf0d;
  text-decoration: underline !important;
}

.colofon p a:hover {
  color: #fff;
}

.logo-on-the-spot-container {
  width: 100px;
}

@media screen and (min-width: 768px) {
  .colofon {
    flex-basis: 800px;
  }
  .colofon p {
    margin-bottom: 20px;
    line-height: 18px;
  }
}
@media screen and (min-width: 1217px) {
  .colofon {
    flex-basis: 1200px;
  }
}
@media screen and (min-width: 1988px) {
  .colofon {
    flex-basis: 1600px;
  }
}
@media screen and (min-width: 2330px) {
  .colofon {
    flex-basis: 2000px;
  }
}
.colofon p strong {
  font-weight: 600;
}

.colofon h2 {
  color: #ffdf0d;
  font-weight: 600;
  margin-bottom: 20px;
}

.highlight_item {
  background: transparent;
  display: flex;
  align-items: stretch;
}

.highlight_item .background {
  height: 100%;
  width: 100%;
}

.highlight_item h2 {
  font-family: "FilsonProBold";
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
  padding-left: 10px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  color: white;
}

.highlight_item h3 {
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  padding-top: 5px;
  padding-left: 10px;
  color: rgb(195, 195, 195);
}

.highlight_item p {
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
}

@media screen and (min-width: 1215px) {
  .highlight_item {
    background: transparent;
    display: flex;
    flex-basis: 800px;
    padding: 15px;
  }
  .highlight_item p {
    font-size: 22px;
    line-height: 30px;
  }
  .highlight_item h2 {
    font-size: 45px;
    line-height: 50px;
    padding-left: 25px;
    padding-top: 15px;
  }
  .highlight_item h3 {
    font-size: 30px;
    line-height: 20px;
    font-weight: 400;
    padding-top: 15px;
    padding-left: 25px;
    color: rgb(195, 195, 195);
  }
  .highlight_item h4 {
    font-size: 28px;
    line-height: 40px;
    font-weight: 400;
  }
}
.content h1 {
  font-weight: 600;
}

.swipe_back_element,
.lees_verder {
  color: black;
  transition: all 0.3s ease-in-out;
}

.lees_verder {
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 1px;
}

.lees_verder_hide {
  display: none;
}

@media screen and (min-width: 768px) {
  .lees_verder {
    display: block;
  }
}
.swipe_back_element:hover {
  transform: translateY(-4px);
  color: red;
  cursor: pointer;
}

.article_content ul {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-left: 0;
}

.article_content ul {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-left: 0;
}

.article_content {
  padding: 15px;
}

.article_content h1 {
  margin-bottom: 15px !important;
  line-height: 35px;
}

.article_content h3 {
  color: #007e79;
}

.article_content p {
  font-size: 16px;
}

.content h3 {
  font-weight: 500;
}

.afbreekbaar {
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
}

figure {
  margin-bottom: 20px;
}

@media screen and (min-width: 768px) {
  .article_content {
    padding: 49px 140px 86px;
  }
  .article_content h1 {
    margin-bottom: 25px !important;
    line-height: 50px;
  }
  .article_content p, li, ol {
    font-size: 20px !important;
    line-height: 28px !important;
  }
  .article_content p strong {
    font-size: 24px;
    line-height: 32px;
    color: #2C3F5B;
  }
}
.lightgallery {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  margin: 0 0;
  margin-bottom: 20px;
}

@media screen and (min-width: 768) {
  .lightgallery {
    grid-template-columns: repeat(3, 1fr);
  }
}
.tekstlogo {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1000;
}

.tekstlogo h1 {
  color: #daebf5 !important;
  font-size: 20px;
  padding: 0;
  margin: 0;
  display: block;
  text-shadow: 0 0 40px rgb(0, 0, 0);
}

.tekstlogo h2 {
  color: white !important;
  font-family: "FilsonProBold";
  font-size: 25px;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  display: block;
}

@media screen and (min-width: 768px) {
  .tekstlogo h1 {
    font-size: 30px;
  }
  .tekstlogo h2 {
    display: block;
    padding-top: 20px;
    font-size: 50px;
    line-height: 56px;
    text-shadow: 0 0 80px rgb(0, 0, 0);
    width: 780px;
  }
}
@media screen and (min-width: 2000px) {
  .tekstlogo h1 {
    font-size: 50px;
  }
  .tekstlogo h2 {
    display: block;
    padding-top: 20px;
    font-size: 80px;
    line-height: 80px;
    text-shadow: 0 0 80px rgb(0, 0, 0);
    width: 1500px;
  }
}
.logobalk {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  background-color: white;
  margin-top: 10px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.logobalk img {
  width: 100%;
  display: block;
  margin: 0;
  padding: 0;
}

@media screen and (min-width: 768px) {
  .logobalk {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
/* Zorg dat de container de juiste hoogte krijgt */
.swiper {
  width: 100%;
  padding: 20px 0; /* ruimte boven en onder de slider */
  background-color: white;
}

/* De wrapper houdt alle slides bij elkaar */
.logobar-wrapper {
  display: flex; /* Swiper gebruikt flex om slides naast elkaar te zetten */
  transition-property: transform; /* animatie bij schuiven */
  box-sizing: content-box;
}

/* Elke slide */
.swiper-slide {
  flex-shrink: 0; /* voorkomt dat slides kleiner worden */
  width: auto; /* kan ook vaste breedte, Swiper rekent automatisch bij slidesPerView */
  display: flex;
  justify-content: center; /* logo in het midden */
  align-items: center;
}

.swiper-slide img {
  max-width: 100%;
  height: auto;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/sass/02_layout/_header.scss","webpack://./src/sass/02_layout/index.scss","webpack://./src/sass/02_layout/_caption.scss","webpack://./src/sass/02_layout/_post.scss","webpack://./src/sass/02_layout/_doek.scss","webpack://./src/sass/02_layout/_content.scss","webpack://./src/sass/02_layout/_colofon.scss","webpack://./src/sass/02_layout/_highlight.scss","webpack://./src/sass/02_layout/_article.scss","webpack://./src/sass/02_layout/_lightgallery.scss","webpack://./src/sass/02_layout/_tekstlogo.scss","webpack://./src/sass/02_layout/_logobalk.scss","webpack://./src/sass/02_layout/_logobar.scss"],"names":[],"mappings":"AAAA;;EAEI,sBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,4CAAA;EACA,YAAA;EACA,yBAAA;ACCJ;;ADEA;EACI,sBAAA;ACCJ;;ADGA;;EAEI,YAAA;ACAJ;;ADGA;EACI,YAAA;ACAJ;;ADGA;EACI,cAAA;EACA,YAAA;EACA,kBAAA;ACAJ;;ADGA;EACI,WAAA;EACA,mBAAA;EACA,cAAA;ACAJ;;ADGA;EACI;IACI,kBAAA;ECAN;AACF;ADGA;EACI,kBAAA;ACDJ;;ADIA;EACI,WAAA;EACA,cAAA;EACA,YAAA,EAAA,iCAAA;EACA,iBAAA;ACDJ;;ACnDA;EACI,eAAA;EACA,iBAAA;ADsDJ;;AEtDA;EACI,sBAAA;EACA,mBAAA;AFyDJ;;AEtDA;EACI,uBAAA;AFyDJ;;AErDA;EACI,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,wBAAA;EACA,uBAAA;AFwDJ;;AErDA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AFwDJ;;AErDA;EACI,gCAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;AFwDJ;;AEpDA;EACI,gBAAA;AFuDJ;;AEjDA;EACI,aAAA;EACA,cAAA;AFoDJ;;AEjDA;EACI,cAAA;AFoDJ;;AEhDA;EAEI;IACA,iBAAA;EFkDF;EE/CE;IACI,gBAAA;IACA,iBAAA;EFiDN;EE7CE;IACI,sBAAA;IACA,wBAAA;IACA,gBAAA;EF+CN;EE5CM;IACA,eAAA;IACA,4BAAA;IACA,yBAAA;EF8CN;AACF;AEzCA;EACI,YAAA;EACA,gCAAA;AF2CJ;;AEvCA;EACI,2BAAA;EACA,UAAA;EACA,eAAA;AF0CJ;;AGxIA;EACI,sBAAA;EACA,0BAAA;EACA,uBAAA;AH2IJ;;AGxIA;EACI,wBAAA;AH2IJ;;AGxIA;EACI,sBAAA;EACA,0BAAA;AH2IJ;;AGvIA;EACI,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;AH0IJ;;AGvIA;EACI,WAAA;AH0IJ;;AGvIA;EACI;IACI,wBAAA;EH0IN;EGvIE;IACA,uBAAA;EHyIF;EGtIE;IACI,uBAAA;EHwIN;EGrIE;IACI,kBAAA;IACA,YAAA;IACA,aAAA;IACA,YAAA;IACA,cAAA;EHuIN;AACF;AGnIA;EAEI;IACI,sBAAA;EHoIN;AACF;AI7LA;EACI,cAAA;AJ+LJ;;AI5LA;EACI,4BAAA;EACA,yBAAA;AJ+LJ;;AI5LA;EACI,4BAAA;AJ+LJ;;AI5LA;EACI,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AJ+LJ;;AKhNA;EACI,aAAA;EACA,aAAA;EACA,aAAA;EACA,iCAAA;ALmNJ;;AK/MA;EACI,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;ALkNJ;;AK/MA;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;ALkNJ;;AK9MA;EACI,cAAA;EACA,qCAAA;ALiNJ;;AK9MA;EACI,WAAA;ALiNJ;;AK7MA;EACI,YAAA;ALgNJ;;AK7MA;EACQ;IACA,iBAAA;ELgNN;EK9ME;IACA,mBAAA;IACA,iBAAA;ELgNF;AACF;AK5MA;EACI;IACI,kBAAA;EL8MN;AACF;AK3MA;EACI;IACI,kBAAA;EL6MN;AACF;AK1MA;EACI;IACI,kBAAA;EL4MN;AACF;AKxMA;EACI,gBAAA;AL0MJ;;AKvMA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;AL0MJ;;AMnRI;EACI,uBAAA;EACA,aAAA;EACA,oBAAA;ANsRR;;AMnRI;EACI,YAAA;EACA,WAAA;ANsRR;;AMlRA;EACI,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;ANqRJ;;AMlRA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;ANqRJ;;AMjRA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;ANoRJ;;AMjRA;EAEI;IACI,uBAAA;IACA,aAAA;IACA,iBAAA;IACA,aAAA;ENmRN;EMhRE;IACI,eAAA;IACA,iBAAA;ENkRN;EM/QE;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;ENiRF;EM9QF;IACI,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,yBAAA;ENgRF;EM7QE;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EN+QF;AACF;AO1VA;EACI,gBAAA;AP4VJ;;AOxVA;;EAEI,YAAA;EACA,gCAAA;AP2VJ;;AOxVA;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AP2VJ;;AOxVA;EACI,aAAA;AP2VJ;;AOvVA;EACI;IACI,cAAA;EP0VN;AACF;AOpVA;EACI,2BAAA;EACA,UAAA;EACA,eAAA;APsVJ;;AOnVA;EACI,yBAAA;EACA,0BAAA;EACA,eAAA;APsVJ;;AOnVA;EACI,yBAAA;EACA,0BAAA;EACA,eAAA;APsVJ;;AOnVA;EACI,aAAA;APsVJ;;AOnVA;EACI,8BAAA;EACA,iBAAA;APsVJ;;AOnVA;EACK,cAAA;APsVL;;AOnVA;EACI,eAAA;APsVJ;;AOnVA;EACI,gBAAA;APsVJ;;AOlVA;EACI,yBAAA;EACA,sBAAA;EACA,aAAA;APqVJ;;AOlVA;EACI,mBAAA;APqVJ;;AOlVA;EAEI;IACI,wBAAA;EPoVN;EOlVE;IACI,8BAAA;IACA,iBAAA;EPoVN;EOlVE;IACI,0BAAA;IACA,4BAAA;EPoVN;EOjVE;IACI,eAAA;IACA,iBAAA;IACA,cAAA;EPmVN;AACF;AQxbA;EACI,aAAA;EACA,qCAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;AR0bJ;;AQvbA;EAEI;IACI,qCAAA;ERybN;AACF;ASrcA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;ATucJ;;ASpcA;EAEI,yBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,kCAAA;ATscJ;;ASncA;EACM,uBAAA;EACF,4BAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;ATscJ;;ASlcA;EACA;IACI,eAAA;ETqcF;ESncF;IACI,cAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;IACA,kCAAA;IACA,YAAA;ETqcF;AACF;ASjcA;EACA;IACI,eAAA;ETmcF;ESjcF;IACI,cAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;IACA,kCAAA;IACA,aAAA;ETmcF;AACF;AUzfA;EACI,aAAA;EACA,8BAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AV2fJ;;AUvfA;EACI,WAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AV0fJ;;AUtfA;EACA;IACI,sCAAA;EVyfF;AACF;AW/gBA,kDAAA;AACA;EACI,WAAA;EACA,eAAA,EAAA,oCAAA;EACA,uBAAA;AXihBJ;;AW9gBA,4CAAA;AACA;EACI,aAAA,EAAA,0DAAA;EACA,8BAAA,EAAA,0BAAA;EACA,uBAAA;AXihBJ;;AW9gBA,eAAA;AACA;EACI,cAAA,EAAA,uCAAA;EACA,WAAA,EAAA,uEAAA;EACA,aAAA;EACA,uBAAA,EAAA,uBAAA;EACA,mBAAA;AXihBJ;;AW9gBA;EACI,eAAA;EACA,YAAA;EACA,cAAA;AXihBJ","sourcesContent":[".header,\nhtml {\n    background-color: #ddd;\n    border-bottom: none;\n}\n\n.header {\n    box-shadow: 0 0 15px -6px rgba(0, 0, 0, .9);\n    z-index: 800;\n    background-color: #af2811;\n}\n\n.lichtgroen {\n    background-color: #ddd;\n}\n\n\n.overzicht,\n.light {\n    color: black;\n}\n\nheader .menu_main li a {\n    color: black;\n}\n\n.wel_logo_liggend {\n    display: block;\n    width: 200px;\n    padding-left: 20px;\n}\n\n.wel_logo_liggend img {\n    width: 100%;\n    object-fit: contain; \n    display: block;      \n}\n\n@media screen and (min-width: 768px) {\n    .wel_logo_liggend {\n        padding-left: auto;\n}    \n}\n\n.start_offset {\n    position: relative;\n}\n\n.start_offset::before {\n    content: \"\";\n    display: block;\n    height: 80px; /* ruimte die je wilt offsetten */\n    margin-top: -80px;\n}\n",".header,\nhtml {\n  background-color: #ddd;\n  border-bottom: none;\n}\n\n.header {\n  box-shadow: 0 0 15px -6px rgba(0, 0, 0, 0.9);\n  z-index: 800;\n  background-color: #af2811;\n}\n\n.lichtgroen {\n  background-color: #ddd;\n}\n\n.overzicht,\n.light {\n  color: black;\n}\n\nheader .menu_main li a {\n  color: black;\n}\n\n.wel_logo_liggend {\n  display: block;\n  width: 200px;\n  padding-left: 20px;\n}\n\n.wel_logo_liggend img {\n  width: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n@media screen and (min-width: 768px) {\n  .wel_logo_liggend {\n    padding-left: auto;\n  }\n}\n.start_offset {\n  position: relative;\n}\n\n.start_offset::before {\n  content: \"\";\n  display: block;\n  height: 80px; /* ruimte die je wilt offsetten */\n  margin-top: -80px;\n}\n\nfigcaption {\n  font-size: 16px;\n  padding-left: 0px;\n}\n\n.post_item {\n  background-color: #000;\n  border-bottom: none;\n}\n\n.post_info {\n  background-color: white;\n}\n\n.post_img {\n  background-repeat: no-repeat;\n  background-position-x: center;\n  background-position-y: center;\n  background-size: cover;\n  display: block;\n  height: 100px !important;\n  width: 120px !important;\n}\n\n.white_shape {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.post_title {\n  font-family: \"Anton\", sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: black;\n  font-weight: 600;\n  padding-bottom: 20px;\n  font-size: 25px;\n  line-height: 30px;\n}\n\n.post_text {\n  font-weight: 500;\n}\n\n.post {\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.content {\n  padding-top: 0;\n}\n\n@media screen and (min-width: 768px) {\n  .content {\n    padding-top: 15px;\n  }\n  .post {\n    margin-top: 15px;\n    padding-top: 15px;\n  }\n  .post_img {\n    width: 100% !important;\n    height: 260px !important;\n    overflow: hidden;\n  }\n  .post_title {\n    font-size: 35px;\n    line-height: 37px !important;\n    color: #af2811 !important;\n  }\n}\n.post_button a {\n  color: black;\n  transition: all 0.3s ease-in-out;\n}\n\n.post_button a:hover {\n  transform: translateY(-4px);\n  color: red;\n  cursor: pointer;\n}\n\n#doek {\n  width: 100% !important;\n  min-width: auto !important;\n  height: auto !important;\n}\n\n#doek img {\n  height: 300px !important;\n}\n\n.swiper-wrapper {\n  width: 100% !important;\n  min-width: auto !important;\n}\n\n.wel_logo {\n  width: 500px !important;\n  height: 60px !important;\n  position: absolute;\n  left: 20px;\n  top: 20px;\n  z-index: 501;\n  display: block;\n}\n\n.wel_logo img {\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  #doek {\n    height: 100vh !important;\n  }\n  #doek img {\n    height: auto !important;\n  }\n  .swiper-wrapper {\n    height: auto !important;\n  }\n  .wel_logo {\n    position: absolute;\n    width: 100px;\n    bottom: 150px;\n    z-index: 501;\n    display: block;\n  }\n}\n@media screen and (min-width: 2000px) {\n  #doek img {\n    height: 80% !important;\n  }\n}\n.content {\n  margin: 0 auto;\n}\n\nh1 {\n  font-family: \"FilsonProBold\";\n  color: #af2811 !important;\n}\n\nh3 {\n  font-family: \"FilsonProBold\";\n}\n\nh5 {\n  text-transform: uppercase;\n  font-size: 16px;\n  letter-spacing: 1px;\n  color: black;\n}\n\n.footer {\n  display: flex;\n  margin-top: 0;\n  height: 200px;\n  background-color: #000 !important;\n}\n\n.colofon {\n  color: #fff;\n  display: flex !important;\n  flex-basis: 100%;\n  margin: 0 auto;\n}\n\n.colofon p {\n  margin-bottom: 20px;\n  line-height: 18px;\n  font-size: 12px;\n}\n\n.colofon p a {\n  color: #ffdf0d;\n  text-decoration: underline !important;\n}\n\n.colofon p a:hover {\n  color: #fff;\n}\n\n.logo-on-the-spot-container {\n  width: 100px;\n}\n\n@media screen and (min-width: 768px) {\n  .colofon {\n    flex-basis: 800px;\n  }\n  .colofon p {\n    margin-bottom: 20px;\n    line-height: 18px;\n  }\n}\n@media screen and (min-width: 1217px) {\n  .colofon {\n    flex-basis: 1200px;\n  }\n}\n@media screen and (min-width: 1988px) {\n  .colofon {\n    flex-basis: 1600px;\n  }\n}\n@media screen and (min-width: 2330px) {\n  .colofon {\n    flex-basis: 2000px;\n  }\n}\n.colofon p strong {\n  font-weight: 600;\n}\n\n.colofon h2 {\n  color: #ffdf0d;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.highlight_item {\n  background: transparent;\n  display: flex;\n  align-items: stretch;\n}\n\n.highlight_item .background {\n  height: 100%;\n  width: 100%;\n}\n\n.highlight_item h2 {\n  font-family: \"FilsonProBold\";\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 600;\n  padding-left: 10px;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n  color: white;\n}\n\n.highlight_item h3 {\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n  padding-top: 5px;\n  padding-left: 10px;\n  color: rgb(195, 195, 195);\n}\n\n.highlight_item p {\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 500;\n}\n\n@media screen and (min-width: 1215px) {\n  .highlight_item {\n    background: transparent;\n    display: flex;\n    flex-basis: 800px;\n    padding: 15px;\n  }\n  .highlight_item p {\n    font-size: 22px;\n    line-height: 30px;\n  }\n  .highlight_item h2 {\n    font-size: 45px;\n    line-height: 50px;\n    padding-left: 25px;\n    padding-top: 15px;\n  }\n  .highlight_item h3 {\n    font-size: 30px;\n    line-height: 20px;\n    font-weight: 400;\n    padding-top: 15px;\n    padding-left: 25px;\n    color: rgb(195, 195, 195);\n  }\n  .highlight_item h4 {\n    font-size: 28px;\n    line-height: 40px;\n    font-weight: 400;\n  }\n}\n.content h1 {\n  font-weight: 600;\n}\n\n.swipe_back_element,\n.lees_verder {\n  color: black;\n  transition: all 0.3s ease-in-out;\n}\n\n.lees_verder {\n  text-decoration: none;\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 16px;\n  letter-spacing: 1px;\n}\n\n.lees_verder_hide {\n  display: none;\n}\n\n@media screen and (min-width: 768px) {\n  .lees_verder {\n    display: block;\n  }\n}\n.swipe_back_element:hover {\n  transform: translateY(-4px);\n  color: red;\n  cursor: pointer;\n}\n\n.article_content ul {\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n  padding-left: 0;\n}\n\n.article_content ul {\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n  padding-left: 0;\n}\n\n.article_content {\n  padding: 15px;\n}\n\n.article_content h1 {\n  margin-bottom: 15px !important;\n  line-height: 35px;\n}\n\n.article_content h3 {\n  color: #007e79;\n}\n\n.article_content p {\n  font-size: 16px;\n}\n\n.content h3 {\n  font-weight: 500;\n}\n\n.afbreekbaar {\n  overflow-wrap: break-word;\n  word-break: break-word;\n  hyphens: auto;\n}\n\nfigure {\n  margin-bottom: 20px;\n}\n\n@media screen and (min-width: 768px) {\n  .article_content {\n    padding: 49px 140px 86px;\n  }\n  .article_content h1 {\n    margin-bottom: 25px !important;\n    line-height: 50px;\n  }\n  .article_content p, li, ol {\n    font-size: 20px !important;\n    line-height: 28px !important;\n  }\n  .article_content p strong {\n    font-size: 24px;\n    line-height: 32px;\n    color: #2C3F5B;\n  }\n}\n.lightgallery {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 20px;\n  margin: 0 0;\n  margin-bottom: 20px;\n}\n\n@media screen and (min-width: 768) {\n  .lightgallery {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n.tekstlogo {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 1000;\n}\n\n.tekstlogo h1 {\n  color: #daebf5 !important;\n  font-size: 20px;\n  padding: 0;\n  margin: 0;\n  display: block;\n  text-shadow: 0 0 40px rgb(0, 0, 0);\n}\n\n.tekstlogo h2 {\n  color: white !important;\n  font-family: \"FilsonProBold\";\n  font-size: 25px;\n  padding: 0;\n  margin: 0;\n  padding-top: 10px;\n  display: block;\n}\n\n@media screen and (min-width: 768px) {\n  .tekstlogo h1 {\n    font-size: 30px;\n  }\n  .tekstlogo h2 {\n    display: block;\n    padding-top: 20px;\n    font-size: 50px;\n    line-height: 56px;\n    text-shadow: 0 0 80px rgb(0, 0, 0);\n    width: 780px;\n  }\n}\n@media screen and (min-width: 2000px) {\n  .tekstlogo h1 {\n    font-size: 50px;\n  }\n  .tekstlogo h2 {\n    display: block;\n    padding-top: 20px;\n    font-size: 80px;\n    line-height: 80px;\n    text-shadow: 0 0 80px rgb(0, 0, 0);\n    width: 1500px;\n  }\n}\n.logobalk {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n  background-color: white;\n  margin-top: 10px;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.logobalk img {\n  width: 100%;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n\n@media screen and (min-width: 768px) {\n  .logobalk {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n}\n/* Zorg dat de container de juiste hoogte krijgt */\n.swiper {\n  width: 100%;\n  padding: 20px 0; /* ruimte boven en onder de slider */\n  background-color: white;\n}\n\n/* De wrapper houdt alle slides bij elkaar */\n.logobar-wrapper {\n  display: flex; /* Swiper gebruikt flex om slides naast elkaar te zetten */\n  transition-property: transform; /* animatie bij schuiven */\n  box-sizing: content-box;\n}\n\n/* Elke slide */\n.swiper-slide {\n  flex-shrink: 0; /* voorkomt dat slides kleiner worden */\n  width: auto; /* kan ook vaste breedte, Swiper rekent automatisch bij slidesPerView */\n  display: flex;\n  justify-content: center; /* logo in het midden */\n  align-items: center;\n}\n\n.swiper-slide img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}","figcaption {\n    font-size: 16px;\n    padding-left: 0px;\n}","\n\n.post_item {\n    background-color: #000;\n    border-bottom: none;\n}\n\n.post_info {\n    background-color: white;\n}\n\n\n.post_img {\n    background-repeat: no-repeat;\n    background-position-x: center;\n    background-position-y: center;\n    background-size: cover;\n    display: block;\n    height: 100px !important;\n    width: 120px !important;\n}\n\n.white_shape {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.post_title {\n    font-family: \"Anton\", sans-serif;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    color: black;\n    font-weight: 600;\n    padding-bottom: 20px;\n    font-size: 25px;\n    line-height: 30px;\n\n}\n\n.post_text {\n    font-weight: 500;\n}\n\n\n\n\n.post {\n    margin-top: 0;\n    padding-top: 0;\n}\n\n.content {\n    padding-top: 0;\n}\n\n \n@media screen and (min-width: 768px) {\n\n    .content {\n    padding-top: 15px;\n}\n\n    .post {\n        margin-top: 15px;\n        padding-top: 15px;\n}\n\n\n    .post_img {\n        width: 100% !important;\n        height: 260px !important;\n        overflow: hidden;\n    }\n\n        .post_title {\n        font-size: 35px;\n        line-height: 37px!important;\n        color: #af2811!important;\n    }\n} \n\n\n\n.post_button a {\n    color: black;\n    transition: all .3s ease-in-out;\n\n}\n\n.post_button a:hover {\n    transform: translateY(-4px);\n    color: red;\n    cursor: pointer;\n}\n","#doek {\n    width: 100%!important;\n    min-width: auto!important;\n    height: auto!important;\n}\n\n#doek img {\n    height: 300px!important;\n}\n\n.swiper-wrapper {\n    width: 100%!important;\n    min-width: auto!important;\n    // height: 300px!important;\n}\n\n.wel_logo {\n    width: 500px!important;\n    height: 60px!important;\n    position: absolute;\n    left: 20px;\n    top: 20px;\n    z-index: 501;\n    display: block;\n}\n\n.wel_logo img {\n    width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n    #doek {\n        height: 100vh!important;\n    }\n\n    #doek img {\n    height: auto!important;\n}\n\n    .swiper-wrapper {\n        height: auto!important;\n    }\n\n    .wel_logo {\n        position: absolute;\n        width: 100px;\n        bottom: 150px;\n        z-index: 501;\n        display: block;\n    }\n}\n\n\n@media screen and (min-width: 2000px) { \n\n    #doek img {\n        height: 80%!important;\n    }\n\n}\n\n",".content {\n    margin: 0 auto;\n}\n\nh1 {\n    font-family: 'FilsonProBold';\n    color: #af2811!important;\n}\n\nh3 {\n    font-family: 'FilsonProBold';\n}\n\nh5 {\n    text-transform: uppercase;\n    font-size: 16px;\n    letter-spacing: 1px;\n    color: black;\n}",".footer {\n    display: flex;\n    margin-top: 0;\n    height: 200px;\n    background-color: #000!important;\n}\n\n\n.colofon {\n    color: #fff;\n    display: flex!important;\n    flex-basis: 100%;\n    margin: 0 auto;\n}\n\n.colofon p {\n    margin-bottom: 20px;\n    line-height: 18px;\n    font-size: 12px;\n}\n\n\n.colofon p a {\n    color: #ffdf0d;\n    text-decoration: underline!important;\n}\n\n.colofon p a:hover {\n    color: #fff;\n}\n\n\n.logo-on-the-spot-container {\n    width: 100px;\n}\n\n@media screen and (min-width: 768px){\n        .colofon {\n        flex-basis: 800px;\n}\n    .colofon p {\n    margin-bottom: 20px;\n    line-height: 18px;\n}\n}\n\n\n@media screen and (min-width: 1217px){\n    .colofon {\n        flex-basis: 1200px;\n}\n}\n\n@media screen and (min-width: 1988px){\n    .colofon {\n        flex-basis: 1600px;\n}\n}\n\n@media screen and (min-width: 2330px){\n    .colofon {\n        flex-basis: 2000px;\n}\n}\n\n\n.colofon p strong {\n    font-weight: 600;\n}\n\n.colofon h2 {\n    color: #ffdf0d;\n    font-weight: 600;\n    margin-bottom: 20px;\n}","    .highlight_item {\n        background: transparent;\n        display: flex;\n        align-items: stretch;\n    }\n\n    .highlight_item .background {\n        height: 100%;\n        width: 100%;\n    }\n\n\n.highlight_item h2 {\n    font-family: 'FilsonProBold';\n    font-size: 18px;\n    line-height: 22px;\n    font-weight: 600;\n    padding-left: 10px;\n    margin-bottom: 0px;\n    padding-bottom: 0px;\n    color: white;\n}\n\n.highlight_item h3 {\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 400;\n    margin: 0;\n    padding: 0;\n    padding-top: 5px;\n    padding-left: 10px;\n    color: rgb(195, 195, 195)\n}\n\n\n.highlight_item p {\n    font-size: 18px;\n    line-height: 24px;\n    font-weight: 500;\n}\n\n@media screen and (min-width: 1215px) {\n\n    .highlight_item {\n        background: transparent;\n        display: flex;\n        flex-basis: 800px;\n        padding: 15px;\n    }\n\n    .highlight_item p {\n        font-size: 22px;\n        line-height: 30px;\n    }\n\n    .highlight_item h2 {\n    font-size: 45px;\n    line-height: 50px;\n    padding-left: 25px;\n    padding-top: 15px;\n}\n\n.highlight_item h3 {\n    font-size: 30px;\n    line-height: 20px;\n    font-weight: 400;\n    padding-top: 15px;\n    padding-left: 25px;\n    color: rgb(195, 195, 195)\n}\n\n    .highlight_item h4 {\n    font-size: 28px;\n    line-height: 40px;\n    font-weight: 400;\n}\n}",".content h1 {\n    font-weight: 600;\n}\n\n\n.swipe_back_element,\n.lees_verder {\n    color: black;\n    transition: all .3s ease-in-out;\n}\n\n.lees_verder {\n    text-decoration: none;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 16px;\n    letter-spacing: 1px;\n}\n\n.lees_verder_hide {\n    display: none;\n}\n\n\n@media screen and (min-width: 768px) {\n    .lees_verder {\n        display: block;\n    }\n    \n}\n\n\n\n.swipe_back_element:hover {\n    transform: translateY(-4px);\n    color: red;\n    cursor: pointer;\n}\n\n.article_content ul {\n    margin-left: 0!important;\n    padding-left: 0!important;\n    padding-left: 0;\n}\n\n.article_content ul {\n    margin-left: 0!important;\n    padding-left: 0!important;\n    padding-left: 0;\n}\n\n.article_content {\n    padding: 15px;\n}\n\n.article_content h1 {\n    margin-bottom: 15px!important;\n    line-height: 35px;\n}\n\n.article_content h3 {\n     color: #007e79;\n   }\n\n.article_content p {\n    font-size: 16px;\n}\n\n.content h3 {\n    font-weight: 500;\n}\n\n\n.afbreekbaar {\n    overflow-wrap: break-word;\n    word-break: break-word;\n    hyphens: auto;\n}\n\nfigure {\n    margin-bottom: 20px;\n}\n\n@media screen and (min-width: 768px){\n\n    .article_content {\n        padding: 49px 140px 86px;\n    }\n    .article_content h1 {\n        margin-bottom: 25px!important;\n        line-height: 50px;\n    }\n    .article_content p, li, ol {\n        font-size: 20px!important;\n        line-height: 28px!important;\n}\n\n    .article_content p strong {\n        font-size: 24px;\n        line-height: 32px;\n        color: #2C3F5B;\n   }\n}",".lightgallery {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 20px;\n    margin: 0 0;\n    margin-bottom: 20px;\n}\n\n@media screen and (min-width: 768) {\n\n    .lightgallery {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}",".tekstlogo {\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    z-index: 1000;\n}\n\n.tekstlogo h1 {\n \n    color: #daebf5!important;\n    font-size: 20px;\n    padding: 0;\n    margin: 0;\n    display: block;\n    text-shadow: 0 0 40px rgba(0,0,0,5.0);\n}\n\n.tekstlogo h2 {\n      color: white!important;\n    font-family: 'FilsonProBold';\n    font-size: 25px;\n    padding: 0;\n    margin: 0;\n    padding-top: 10px; \n    display: block;\n\n}\n\n@media screen and (min-width: 768px) {\n.tekstlogo h1 {\n    font-size: 30px;\n}\n.tekstlogo h2 {\n    display: block;\n    padding-top: 20px;\n    font-size: 50px;\n    line-height: 56px;\n    text-shadow: 0 0 80px rgba(0,0,0,2.0);\n    width: 780px;\n}\n}\n\n\n@media screen and (min-width: 2000px) {\n.tekstlogo h1 {\n    font-size: 50px;\n}\n.tekstlogo h2 {\n    display: block;\n    padding-top: 20px;\n    font-size: 80px;\n    line-height: 80px;\n    text-shadow: 0 0 80px rgba(0,0,0,2.0);\n    width: 1500px;\n}\n}",".logobalk {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 20px;\n    background-color: white;\n    margin-top: 10px;\n    margin-bottom: 0px;\n    padding-bottom: 0px;\n    // max-height: 100px!important;\n}\n\n.logobalk img {\n    width: 100%;\n    display: block;\n    margin: 0;\n    padding: 0;\n}\n\n\n@media screen and (min-width: 768px) {\n.logobalk {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n}\n}","/* Zorg dat de container de juiste hoogte krijgt */\n.swiper {\n    width: 100%;\n    padding: 20px 0; /* ruimte boven en onder de slider */\n    background-color: white;\n}\n\n/* De wrapper houdt alle slides bij elkaar */\n.logobar-wrapper {\n    display: flex;          /* Swiper gebruikt flex om slides naast elkaar te zetten */\n    transition-property: transform; /* animatie bij schuiven */\n    box-sizing: content-box;\n}\n\n/* Elke slide */\n.swiper-slide {\n    flex-shrink: 0;         /* voorkomt dat slides kleiner worden */\n    width: auto;             /* kan ook vaste breedte, Swiper rekent automatisch bij slidesPerView */\n    display: flex;\n    justify-content: center; /* logo in het midden */\n    align-items: center;\n}\n\n.swiper-slide img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
